import { Extension, mergeAttributes, Node } from "@tiptap/core";
import { VueNodeViewRenderer } from "@tiptap/vue-3";
import SocialsNode from "./SocialsNode.vue";
import SocialElementNode from "./SocialElementNode.vue";
import { createDefaultBlockForTipTap } from "~/stores/mail-block-editor/defaults";

export interface SocialExtensionOptions {
    social?: boolean;
    socials?: boolean;
}

const Socials = Node.create({
    name: "socials",
    group: "socials",
    content: "social*",

    defining: true,

    addAttributes() {
        return createDefaultBlockForTipTap("socials");
    },

    parseHTML() {
        return [
            {
                tag: "div",
            },
        ];
    },

    renderHTML({ HTMLAttributes }) {
        return ["div", mergeAttributes(HTMLAttributes), 0];
    },

    addNodeView() {
        return VueNodeViewRenderer(
            SocialsNode as Parameters<typeof VueNodeViewRenderer>[0],
        );
    },
});

const Social = Node.create({
    name: "social",
    group: "socials",
    content: "inline*",

    addAttributes() {
        return createDefaultBlockForTipTap("social");
    },

    parseHTML() {
        return [
            {
                tag: "a",
            },
        ];
    },

    renderHTML({ HTMLAttributes }) {
        return ["a", mergeAttributes(HTMLAttributes), 0];
    },

    addNodeView() {
        return VueNodeViewRenderer(
            SocialElementNode as Parameters<typeof VueNodeViewRenderer>[0],
        );
    },
});

const SocialExtension = Extension.create<SocialExtensionOptions>({
    name: "social",
    addExtensions() {
        const extensions = [];

        if (this.options.social !== false) {
            extensions.push(Social);
        }

        if (this.options.socials !== false) {
            extensions.push(Socials);
        }

        return extensions;
    },
});

export { SocialExtension, Social, Socials };
